import { Capacitor } from '@capacitor/core';
import { PushNotifications } from '@capacitor/push-notifications';

export const PushService = {
  async init() {
    if (!Capacitor?.isNativePlatform?.()) return { enabled: false };
    try {
      const perm = await PushNotifications.requestPermissions();
      if (perm.receive !== 'granted') {
        return { enabled: false };
      }
      await PushNotifications.register();

      PushNotifications.addListener('registration', token => {
        console.log('[Push] registration token:', token?.value);
        // TODO: send token to backend when endpoint available
      });

      PushNotifications.addListener('registrationError', err => {
        console.warn('[Push] registration error:', err);
      });

      PushNotifications.addListener('pushNotificationReceived', notification => {
        console.log('[Push] received:', notification);
      });

      PushNotifications.addListener('pushNotificationActionPerformed', action => {
        console.log('[Push] action performed:', action);
      });

      return { enabled: true };
    } catch (e) {
      console.warn('[Push] init failed:', e);
      return { enabled: false, error: e?.message };
    }
  }
};

export default PushService;

